import React from 'react';
import { Paper, Typography, makeStyles } from '@material-ui/core';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';

const useStyles = makeStyles((theme) => ({
    card: {
        padding: theme.spacing(2),
        borderRadius: 8,
        border: '1px solid #e8e8e8',
        height: '100%',
        boxSizing: 'border-box',
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        marginBottom: theme.spacing(1),
    },
    label: {
        fontSize: 11,
        fontWeight: 700,
        letterSpacing: '0.08em',
        color: '#0B3F30',
        textTransform: 'uppercase',
        lineHeight: 1.3,
    },
    icon: {
        color: '#3C6559',
        fontSize: 20,
        flexShrink: 0,
        marginLeft: theme.spacing(1),
    },
    value: {
        fontSize: 32,
        fontWeight: 700,
        color: '#0B3F30',
        lineHeight: 1.1,
        marginBottom: theme.spacing(1),
    },
    footer: {
        display: 'flex',
        alignItems: 'center',
        gap: 6,
        flexWrap: 'wrap',
    },
    badge: {
        display: 'inline-flex',
        alignItems: 'center',
        borderRadius: 4,
        padding: '1px 6px',
        fontSize: 12,
        fontWeight: 600,
        lineHeight: 1.6,
    },
    badgeDown: {
        backgroundColor: '#fde8e8',
        color: '#c62828',
    },
    badgeUp: {
        backgroundColor: '#e8f5e9',
        color: '#2e7d32',
    },
    subtext: {
        fontSize: 12,
        color: '#92B1A7',
    },
}));

function formatValue(value) {
    if (value == null) return '—';
    if (typeof value !== 'number') return String(value);
    if (value >= 1000000) return `${(value / 1000000).toFixed(1)}M`;
    if (value >= 1000) return `${(value / 1000).toFixed(1)}K`;
    return String(value);
}

export default function StatCard({ label, value, change, icon: Icon, absolute, subtext }) {
    const classes = useStyles();
    const isPositive = change >= 0;

    return (
        <Paper className={classes.card} elevation={0}>
            <div className={classes.header}>
                <Typography className={classes.label}>{label}</Typography>
                {Icon && <Icon className={classes.icon} />}
            </div>
            <Typography className={classes.value}>{formatValue(value)}</Typography>
            {change != null && (
                <div className={classes.footer}>
                    <span
                        className={`${classes.badge} ${change === 0 || isPositive ? classes.badgeUp : classes.badgeDown}`}
                    >
                        {isPositive ? (
                            <ArrowDropUpIcon style={{ fontSize: 24, verticalAlign: 'middle' }} />
                        ) : (
                            <ArrowDropDownIcon style={{ fontSize: 24, verticalAlign: 'middle' }} />
                        )}
                        {absolute ? Math.abs(change) : `${Math.abs(change)}%`}
                    </span>
                    <span className={classes.subtext}>{subtext ?? 'Nei praėjusį mėn.'}</span>
                </div>
            )}
        </Paper>
    );
}
